import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "menuIcon", "closeIcon"]

  toggle(event) {
    event.preventDefault()
    const isHidden = this.menuTarget.classList.contains('hidden')
    
    if (isHidden) {
      this.menuTarget.classList.remove('hidden')
      this.menuIconTarget.classList.add('hidden')
      this.closeIconTarget.classList.remove('hidden')
    } else {
      this.close()
    }
  }

  close() {
    this.menuTarget.classList.add('hidden')
    this.menuIconTarget.classList.remove('hidden')
    this.closeIconTarget.classList.add('hidden')
  }
}
